import { ListPage } from "@/components/v2/list-page";
import { EmptyState } from "@/components/v2/empty-state";

export default function V2ReportsPage() {
  return (
    <ListPage title="Reports">
      <EmptyState
        title="No reports available"
        description="Reports will appear here as your data grows."
      />
    </ListPage>
  );
}
